import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Card from 'components/inputs/Card';
import { MdClose } from 'react-icons/md';
import { Row, Col } from 'react-bootstrap';
import { Formik, Form } from 'formik';
import TextInput from 'components/inputs/Input';
import Button from 'components/inputs/Button';
import _ from 'lodash';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { CREATE_CHARGE_SPEED, UPDATE_CHARGE_SPEED } from 'actions/chargeSpeed';
import { CREATE_STATUS_CODE, UPDATE_STATUS_CODE } from 'components/common/constant';

const ChargeSpeedSchema = Yup.object().shape({
  name: Yup.string()
    .required('Charging station speed is required')
    .strict(true)
    .trim('Space is not allowed')
    .matches(/^[A-Za-z\s]+$/, 'Only alphabets are allowed')
    .max(100, 'Text limit should be less than 100 characters'),
});

const ChargeSpeedForm = (props) => {
  const { isEdit, onClose = _.noop(), onSuccess = _.noop() } = props;
  const dispatch = useDispatch();

  const chargeSpeedDetail = useSelector((state) => state.chargeSpeed.chargeSpeedDetail);
  const isLoading = useSelector((state) => state.chargeSpeed.isLoading);

  const addChargeSpeed = useCallback((data) => {
    dispatch({
      type: CREATE_CHARGE_SPEED,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === CREATE_STATUS_CODE) {
          onSuccess();
          onClose();
        }
      },
    });
  }, []);

  const updateChargeSpeed = useCallback((data) => {
    dispatch({
      type: UPDATE_CHARGE_SPEED,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
          onClose();
        }
      },
    });
  }, []);

  const initialValues = isEdit
    ? { ...chargeSpeedDetail }
    : {
        name: '',
      };
  return (
    <React.Fragment>
      <div className="chargeSpeed-form-page__main">
        <Card>
          <div className="chargeSpeed-form-header__block">
            <div className="chargeSpeed-header-name">
              <span>{isEdit ? 'Edit' : 'Add'} Charge Speed </span>
            </div>
            <div className="close___btn">
              <MdClose size={30} color="#BE210B" onClick={onClose} />
            </div>
          </div>
          <div className="chargeSpeed-form-body__block">
            <div className="chargeSpeed-form--block">
              <Formik
                enableReinitialize={!!isEdit}
                initialValues={initialValues}
                validationSchema={ChargeSpeedSchema}
                onSubmit={(values, { setSubmitting }) => {
                  if (isEdit) {
                    updateChargeSpeed(values);
                  } else {
                    addChargeSpeed(values);
                  }
                  setSubmitting(false);
                }}
              >
                {({ values, errors, touched, handleSubmit, handleChange, isSubmitting }) => (
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col>
                        <TextInput
                          isRequired
                          label="Charging Station Speed"
                          placeholder="Charging station speed"
                          name="name"
                          value={_.get(values, 'name', '')}
                          onChange={handleChange}
                          error={errors.name && touched.name ? errors.name : null}
                        />
                      </Col>
                    </Row>
                    <div className="form-btn__block">
                      <Button className="form_btn cancel____btn" onClick={onClose}>
                        Cancel
                      </Button>
                      <Button type="submit" disabled={isSubmitting || isLoading} className="form_btn">
                        {isEdit ? 'Edit' : 'Add'}
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </Card>
      </div>
    </React.Fragment>
  );
};
ChargeSpeedForm.propTypes = {
  onSuccess: PropTypes.func,
  onClose: PropTypes.func,
  isEdit: PropTypes.bool,
};
export default ChargeSpeedForm;
